import { useEffect, useState } from "react";
import dayjs from "dayjs";

function useMinutesAgo(dateString) {
  const [minutes, setMinutes] = useState(null);

  useEffect(() => {
    if (!dateString) return;

    const update = () => {
      const diff = dayjs().diff(dayjs(dateString), "minute");
      setMinutes(diff);
    };

    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, [dateString]);

  if (minutes === null) return "";
  return `${minutes} Mins`;
}

export default useMinutesAgo;
